import { atom, AtomOptions } from "recoil";
import _ from "lodash";

const sessionStorageEffect =
  <T>(
    key: string,
    defaultValue: T,
    omitKeys: string[] = [],
    reflector: (val: T) => T = _.identity,
  ) =>
    ({ setSelf, onSet }: { setSelf: (value: T) => void; onSet: (callback: (newValue: T) => void) => void }) => {
      const storageKey = `persistAtom:${key}`;
      const savedValue = sessionStorage.getItem(storageKey);

      if (savedValue !== null) {
        const parsedSavedValue = _.omit(JSON.parse(savedValue), ...omitKeys);
        const value = _.merge(_.cloneDeep(defaultValue), parsedSavedValue) as T;
        setSelf(reflector(value));
      }
      onSet((newValue: T) => {
        sessionStorage.setItem(storageKey, JSON.stringify(_.omit(newValue as object, ...omitKeys)));
      });
    };

export const persistAtom = <T>(atomOptions: AtomOptions<T> & { default: T } & { omitPersistKeys?: string[] } & { reflector?: (val: T) => T }) =>
  atom<T>({
    ...atomOptions,
    effects: [...(atomOptions.effects || []), sessionStorageEffect(atomOptions.key, atomOptions.default, atomOptions.omitPersistKeys, atomOptions.reflector)],
  });
